import React from "react";

export default function Ekg() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="10 0 22 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="6.3"
        y="9.3"
        width="18.4"
        height="14.7056"
        rx="1.58889"
        stroke="#545454"
        strokeWidth="0.6"
      />
      <path
        d="M8.63893 10.8333H22.3612C22.806 10.8333 23.1667 11.1939 23.1667 11.6388V19.0277C23.1667 19.4726 22.806 19.8333 22.3612 19.8333H8.63893C8.19403 19.8333 7.83337 19.4726 7.83337 19.0277V11.6388C7.83337 11.1939 8.19403 10.8333 8.63893 10.8333Z"
        stroke="#545454"
        strokeWidth="0.5"
      />
      <path
        d="M7.84717 15.0834C7.7091 15.0834 7.59717 15.1954 7.59717 15.3334C7.59717 15.4715 7.7091 15.5834 7.84717 15.5834V15.0834ZM8.90272 15.3334V15.5834C8.99742 15.5834 9.08398 15.5299 9.12633 15.4452L8.90272 15.3334ZM9.4305 14.2779L9.66458 14.1901C9.62967 14.097 9.5429 14.0334 9.4436 14.0282C9.34431 14.023 9.25136 14.0771 9.20689 14.1661L9.4305 14.2779ZM10.2222 16.389L9.98809 16.4768C10.0253 16.5759 10.1209 16.6409 10.2268 16.639C10.3327 16.637 10.4258 16.5685 10.4593 16.4681L10.2222 16.389ZM11.5416 12.4307L11.7872 12.3839C11.7659 12.2721 11.6718 12.1888 11.5583 12.1812C11.4448 12.1736 11.3404 12.2437 11.3044 12.3516L11.5416 12.4307ZM12.5972 17.9723L12.3516 18.0191C12.374 18.1366 12.4764 18.2218 12.596 18.2223C12.7156 18.2229 12.8189 18.1386 12.8423 18.0214L12.5972 17.9723ZM13.3888 14.014L13.626 13.9349C13.5902 13.8274 13.4864 13.7574 13.3733 13.7645C13.2602 13.7715 13.1659 13.8538 13.1437 13.965L13.3888 14.014ZM13.9166 15.5973L13.6794 15.6764C13.7114 15.7723 13.798 15.8395 13.8989 15.8467C13.9998 15.8539 14.095 15.7996 14.1402 15.7091L13.9166 15.5973ZM14.4444 14.5418L14.668 14.43C14.6256 14.3453 14.5391 14.2918 14.4444 14.2918C14.3497 14.2918 14.2631 14.3453 14.2208 14.43L14.4444 14.5418ZM14.9722 15.5973L14.7486 15.7091C14.7909 15.7938 14.8775 15.8473 14.9722 15.8473V15.5973ZM15.7638 15.5973L15.9638 15.4473C15.9166 15.3844 15.8425 15.3473 15.7638 15.3473V15.5973ZM16.5555 16.6529L16.3555 16.8029C16.4121 16.8784 16.5064 16.9155 16.5993 16.899C16.6922 16.8825 16.7678 16.8151 16.795 16.7247L16.5555 16.6529ZM17.3472 14.014L17.5908 13.9578C17.5653 13.8473 17.4686 13.7678 17.3552 13.7641C17.2419 13.7605 17.1403 13.8335 17.1077 13.9422L17.3472 14.014ZM18.1388 17.4446L17.8952 17.5008C17.9225 17.6189 18.0306 17.7004 18.1516 17.6942C18.2727 17.688 18.3719 17.5959 18.3869 17.4756L18.1388 17.4446ZM18.6666 13.2223L18.9111 13.1699C18.8855 13.0507 18.7776 12.9673 18.6558 12.9726C18.5339 12.9779 18.4337 13.0703 18.4185 13.1913L18.6666 13.2223ZM19.4583 16.9168L19.2138 16.9692C19.2374 17.0794 19.3319 17.1602 19.4445 17.1664C19.557 17.1726 19.6598 17.1028 19.6954 16.9958L19.4583 16.9168ZM20.2499 14.5418L20.494 14.4875C20.4696 14.3778 20.375 14.2979 20.2628 14.2921C20.1506 14.2863 20.0483 14.3561 20.0128 14.4627L20.2499 14.5418ZM20.7777 16.9168L20.5337 16.971C20.5575 17.078 20.6482 17.1571 20.7575 17.166C20.8668 17.1748 20.9691 17.1114 21.0098 17.0096L20.7777 16.9168ZM21.3055 15.5973V15.3473C21.2033 15.3473 21.1113 15.4096 21.0734 15.5045L21.3055 15.5973ZM23.1527 15.8473C23.2908 15.8473 23.4027 15.7354 23.4027 15.5973C23.4027 15.4593 23.2908 15.3473 23.1527 15.3473V15.8473ZM7.84717 15.5834H8.90272V15.0834H7.84717V15.5834ZM9.12633 15.4452L9.65411 14.3897L9.20689 14.1661L8.67912 15.2216L9.12633 15.4452ZM9.19642 14.3657L9.98809 16.4768L10.4563 16.3012L9.66458 14.1901L9.19642 14.3657ZM10.4593 16.4681L11.7788 12.5097L11.3044 12.3516L9.985 16.3099L10.4593 16.4681ZM11.296 12.4774L12.3516 18.0191L12.8428 17.9256L11.7872 12.3839L11.296 12.4774ZM12.8423 18.0214L13.634 14.063L13.1437 13.965L12.352 17.9233L12.8423 18.0214ZM13.1517 14.0931L13.6794 15.6764L14.1538 15.5183L13.626 13.9349L13.1517 14.0931ZM14.1402 15.7091L14.668 14.6536L14.2208 14.43L13.693 15.4855L14.1402 15.7091ZM14.2208 14.6536L14.7486 15.7091L15.1958 15.4855L14.668 14.43L14.2208 14.6536ZM14.9722 15.8473H15.7638V15.3473H14.9722V15.8473ZM15.5638 15.7473L16.3555 16.8029L16.7555 16.5029L15.9638 15.4473L15.5638 15.7473ZM16.795 16.7247L17.5866 14.0858L17.1077 13.9422L16.316 16.581L16.795 16.7247ZM17.1036 14.0702L17.8952 17.5008L18.3824 17.3883L17.5908 13.9578L17.1036 14.0702ZM18.3869 17.4756L18.9147 13.2533L18.4185 13.1913L17.8908 17.4135L18.3869 17.4756ZM18.4222 13.2747L19.2138 16.9692L19.7027 16.8644L18.9111 13.1699L18.4222 13.2747ZM19.6954 16.9958L20.4871 14.6208L20.0128 14.4627L19.2211 16.8377L19.6954 16.9958ZM20.0059 14.596L20.5337 16.971L21.0218 16.8625L20.494 14.4875L20.0059 14.596ZM21.0098 17.0096L21.5376 15.6902L21.0734 15.5045L20.5456 16.8239L21.0098 17.0096ZM21.3055 15.8473H23.1527V15.3473H21.3055V15.8473Z"
        fill="#545454"
      />
      <line
        x1="6"
        y1="20.9278"
        x2="25"
        y2="20.9278"
        stroke="#545454"
        strokeWidth="0.422222"
      />
      <circle
        cx="8.37504"
        cy="22.4584"
        r="0.591667"
        stroke="#545454"
        strokeWidth="0.4"
      />
      <mask id="path-6-inside-1_228_1360" fill="white">
        <rect
          x="15.5"
          y="22.1943"
          width="1.58333"
          height="1.05556"
          rx="0.263889"
        />
      </mask>
      <rect
        x="15.5"
        y="22.1943"
        width="1.58333"
        height="1.05556"
        rx="0.263889"
        stroke="#545454"
        strokeWidth="0.8"
        mask="url(#path-6-inside-1_228_1360)"
      />
      <mask id="path-7-inside-2_228_1360" fill="white">
        <rect
          x="17.6111"
          y="22.1943"
          width="1.58333"
          height="1.05556"
          rx="0.263889"
        />
      </mask>
      <rect
        x="17.6111"
        y="22.1943"
        width="1.58333"
        height="1.05556"
        rx="0.263889"
        stroke="#545454"
        strokeWidth="0.8"
        mask="url(#path-7-inside-2_228_1360)"
      />
      <mask id="path-8-inside-3_228_1360" fill="white">
        <rect
          x="19.7222"
          y="22.1943"
          width="1.58333"
          height="1.05556"
          rx="0.263889"
        />
      </mask>
      <rect
        x="19.7222"
        y="22.1943"
        width="1.58333"
        height="1.05556"
        rx="0.263889"
        stroke="#545454"
        strokeWidth="0.8"
        mask="url(#path-8-inside-3_228_1360)"
      />
      <mask id="path-9-inside-4_228_1360" fill="white">
        <rect
          x="21.8334"
          y="22.1943"
          width="1.58333"
          height="1.05556"
          rx="0.263889"
        />
      </mask>
      <rect
        x="21.8334"
        y="22.1943"
        width="1.58333"
        height="1.05556"
        rx="0.263889"
        stroke="#545454"
        strokeWidth="0.8"
        mask="url(#path-9-inside-4_228_1360)"
      />
    </svg>
  );
}
